import { useSyncExternalStore } from 'react';
import { useStytch } from '../GlobalContextProvider.mjs';

// useStytchMember is a very lightweight copy-pasta of the hook from stytch-react
// If we end up calling this in several places, consider hoisting to global context
const useStytchMember$1 = ()=>{
    const stytch = useStytch();
    return useSyncExternalStore(stytch.onStateChange, ()=>stytch.self.getSync());
};

export { useStytchMember$1 as useStytchMember };
//# sourceMappingURL=useStytchMember.mjs.map
